import { proxy } from "valtio";

export const windowSizeState = proxy({
  currentWidth: window.innerWidth,
  currentHeight: window.innerHeight,

  get mobileMode() {
    return this.currentWidth <= 1024 && this.currentWidth < this.currentHeight;
  },
  get phoneMode() {
    return this.currentWidth <= 550;
  },
  get isMobileRotate() {
    return this.currentWidth < 768;
  },
  get isLandscapePhone() {
    return (
      this.currentWidth < 1024 &&
      this.currentHeight <= 550 &&
      this.currentWidth > this.currentHeight
    );
  },
  get isLandscape() {
    return (
      this.currentWidth > this.currentHeight &&
      this.currentWidth > 1024 &&
      this.currentHeight > 550
    );
  },
});

const handleResize = () => {
  windowSizeState.currentWidth = window.innerWidth;
  windowSizeState.currentHeight = window.innerHeight;
};

window.addEventListener("resize", handleResize);
